"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  en: {
    fields: {
      messages: {
        hideNotesConfirm: 'Are you sure you want to hide the Note? You will lose its content.'
      },
      actions: {
        addNote: 'Add Note',
        removeNote: 'Remove Note',
        unlock: 'Unlock'
      }
    }
  }
};
var _default = messages;
exports.default = _default;